module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search_panel":"Search Panel","list_quotaion":"Quotation List"},"si":{"search_panel":"සෙවුම් පැනලය","list_quotaion":"ලැයිස්තු උපුටා දැක්වීම"}}')
  delete Component.options._Ctor
}
